import { render, staticRenderFns } from "./editOrCreate.vue?vue&type=template&id=6aba0562&scoped=true&"
import script from "./editOrCreate.vue?vue&type=script&lang=js&"
export * from "./editOrCreate.vue?vue&type=script&lang=js&"
import style0 from "./editOrCreate.vue?vue&type=style&index=0&id=6aba0562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aba0562",
  null
  
)

export default component.exports